export default [
  {
    number: 24,
    class: 'muted',
    title: ''
  },
  {
    number: 25,
    class: 'muted',
    title: ''
  },
  {
    number: 26,
    class: 'muted',
    title: ''
  },
  {
    number: 27,
    class: 'muted',
    title: ''
  },
  {
    number: 28,
    class: 'muted',
    title: ''
  },
  {
    number: 1,
    class: '',
    title: ''
  },
  {
    number: 2,
    class: '',
    title: ''
  },
  {
    number: 3,
    class: '',
    title: ''
  },
  {
    number: 4,
    class: 'off',
    title: 'Recesso - Não haverá aula'
  },
  {
    number: 5,
    class: 'off',
    title: 'Carnaval - Não haverá aula'
  },
  {
    number: 6,
    class: 'off',
    title: 'Quarta-feira de Cinzas - Não haverá aula'
  },
  {
    number: 7,
    class: '',
    title: ''
  },
  {
    number: 8,
    class: '',
    title: ''
  },
  {
    number: 9,
    class: '',
    title: ''
  },
  {
    number: 10,
    class: '',
    title: ''
  },
  {
    number: 11,
    class: '',
    title: ''
  },
  {
    number: 12,
    class: '',
    title: ''
  },
  {
    number: 13,
    class: 'class',
    title: 'dev.learn("avançado") - Rest API com Node e MongoDB part.1 - Sala 3010 das 12:30 as 14:00'
  },
  {
    number: 14,
    class: 'class',
    title: 'dev.learn("básico") - Web e Internet - Sala 3009 das 14:00 as 15:40'
  },
  {
    number: 15,
    class: '',
    title: ''
  },
  {
    number: 16,
    class: 'class',
    title: `dev.learn("básico") - Web e Internet - Sala 4005 das 13:00 as 14:40 - 
    dev.learn("avançado") - Rest API com Node e MongoDB part.1 - Sala 4005 das 16:00 as 17:30 - 
    OBS: O conteudo dessas aulas é o mesmo que a de quarta e quinta`
  },
  {
    number: 17,
    class: '',
    title: ''
  },
  {
    number: 18,
    class: '',
    title: ''
  },
  {
    number: 19,
    class: '',
    title: ''
  },
  {
    number: 20,
    class: 'class',
    title: 'dev.learn("avançado") - Rest API com Node e MongoDB part.2 - Sala 3010 das 12:00 as 14:00'
  },
  {
    number: 21,
    class: 'class',
    title: 'dev.learn("básico") - HTML - Sala 3009 das 14:00 as 16:00'
  },
  {
    number: 22,
    class: '',
    title: ''
  },
  {
    number: 23,
    class: 'class',
    title: `dev.learn("básico") - HTML - Sala 4005 das 13:00 as 15:00 - 
    dev.learn("avançado") - Rest API com Node e MongoDB part.2 - Sala 4005 das 15:00 as 17:00 - 
    OBS: O conteudo dessas aulas é o mesmo que a de quarta e quinta`
  },
  {
    number: 24,
    class: '',
    title: ''
  },
  {
    number: 25,
    class: '',
    title: ''
  },
  {
    number: 26,
    class: '',
    title: ''
  },
  {
    number: 27,
    class: '',
    title: ''
  },
  {
    number: 28,
    class: 'class',
    title: 'dev.learn("básico") - CSS part.1 - Sala 3009 das 14:00 as 15:40'
  },
  {
    number: 29,
    class: '',
    title: ''
  },
  {
    number: 30,
    class: 'class',
    title: `dev.learn("básico") - CSS part.1 - Sala 6305 das 13:00 as 14:40 - 
    dev.learn("avançado") - React - Sala 6305 das 15:00 as 16:40 - 
    OBS: O conteudo dessas aulas é o mesmo que a de quarta e quinta`
  },
  {
    number: 31,
    class: '',
    title: ''
  },
  {
    number: 1,
    class: 'muted',
    title: ''
  },
  {
    number: 2,
    class: 'muted',
    title: ''
  },
  {
    number: 3,
    class: 'muted',
    title: ''
  },
  {
    number: 4,
    class: 'muted',
    title: ''
  },
  {
    number: 5,
    class: 'muted',
    title: ''
  },
  {
    number: 6,
    class: 'muted',
    title: ''
  },
]